// @ts-check
import React, { forwardRef } from "react"
import Button from "../../atoms/Button.atom"
import PropTypes from "prop-types"
import { chooseButtonClass } from "../../../utils/buttons.utils"
import { clsx } from "../../../utils/strings.utils"

/** @type {import("./PrimaryButton.molecule")["default"]} */
const PrimaryButton = forwardRef(
  ({ btnType, rounded = true, borderAccent = false, ...props }, ref) => {
    return props.viewOnly ? null : (
        <Button
          {...props}
          className={clsx(
            "p-button-primary",
            btnType && chooseButtonClass(btnType),
            rounded && "border-round-3xl",
            btnType !== "outlined" && "bg-primary-highlight",
            borderAccent && "border-primary-accent",
            props.className
          )}
          ref={ref}
        />
      )
  }
)

const propTypes = {
  label: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  onClick: PropTypes.func,
  rounded: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  className: PropTypes.string,
  viewOnly: PropTypes.bool,
  borderAccent: PropTypes.bool,
  btnType: PropTypes.oneOf(["text", "outlined", "block", "link", "rounded"]),
}

// @ts-ignore
PrimaryButton.propTypes = propTypes

export default PrimaryButton
